import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { useTheme } from '@hivebrite/design-system/Theme';

import type { RenderProps } from 'hb-builder/components/common/type/RenderProps';
import { Wrapper } from 'hb-builder/components/common/Wrapper/WrapperRender';
import ButtonUI from 'hb-builder/components/UIComponents/shared/single/Button/ButtonUI';
import { useRendererContext } from 'hb-builder/hooks';
import type { RenderComponent } from 'hb-builder/types';
import { getJustifyContent } from 'hb-builder/utils/attributes';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { ButtonItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/buttonItemAttributes';

const componentType = 'single';

const Button: RenderComponent = () => <div />; // never used

const Render = ({ item }: RenderProps<DocumentItem<ButtonItemAttributes>>) => {
  const { isMobilePreview, networkFont } = useRendererContext();
  const theme = useTheme();

  if (!item) {
    return null;
  }

  const { attributes } = item;

  if (attributes?.hidden) {
    return null;
  }

  return (
    /* @ts-expect-error untyped */
    <Wrapper
      attributes={attributes}
      componentType={componentType}
      dataTestId="builder-component-button"
      isMobilePreview={isMobilePreview}
      style={{
        width: '100%',
      }}
    >
      <StyledWrapper
        $fontFamily={attributes?.buttonFontFamily || networkFont}
        $horizontalAlign={attributes?.horizontalAlign}
      >
        <ButtonUI attributes={attributes} theme={theme}>
          {item.content}
        </ButtonUI>
      </StyledWrapper>
    </Wrapper>
  );
};

Button.componentName = 'Button';
Button.Render = Render;

export default Button;

interface StyledWrapperProps {
  $containerPadding?: string | number;
  $fontFamily?: string | null;
  $horizontalAlign?: string;
}

const StyledWrapper = styled(Box).attrs<StyledWrapperProps>(
  ({ $horizontalAlign }) => ({
    justifyContent: getJustifyContent($horizontalAlign),
    width: '100%',
  }),
)<StyledWrapperProps>`
  > div {
    width: 100%;
  }

  a {
    justify-content: ${({ $horizontalAlign }) =>
      getJustifyContent($horizontalAlign)};
    text-decoration: none !important;
    width: 100%;
  }

  button {
    line-height: 1.5;
    ${({ $fontFamily }) =>
      $fontFamily && `font-family: ${$fontFamily} !important;`}
  }
`;
